import script from "./UploadsRepository.vue?vue&type=script&lang=js"
export * from "./UploadsRepository.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__